import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UsbOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"usb_off"}/>
}
